import { render, staticRenderFns } from "./RegisterationComplete.vue?vue&type=template&id=69b18115&scoped=true&"
import script from "./RegisterationComplete.vue?vue&type=script&lang=js&"
export * from "./RegisterationComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegisterationComplete.vue?vue&type=style&index=0&id=69b18115&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b18115",
  null
  
)

export default component.exports